/**
 * @mixin
 */
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: ""
        },
        value: {
            default: null
        },
        placeholder: {
            type: String,
            default: ""
        },
        editable: {
            type: Boolean,
            default: true
        }
    }
}
